import { render, staticRenderFns } from "./UserGroupActions.vue?vue&type=template&id=fe4a8322&"
import script from "./UserGroupActions.vue?vue&type=script&lang=js&"
export * from "./UserGroupActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports